import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const Home = () => import('@/views/Home')
const Chart = () => import('@/views/Chart')
// const Production = () => import('@/views/Production')
// const ThreeNav = () => import('@/views/ThreeNav')
// const FourNav = () => import('@/views/FourNav')
// const FiveNav = () => import('@/views/FiveNav')
const Demo = () => import('@/views/Demo')

// const NewsDetails = () => import('@/components/report_list/NewsDetails.vue')
const NewsDetailMobile = () => import('@/views/NewsDetailMobile.vue')
// const NewsDetailsTwo = () => import('@/components/report_list/NewsDetailsTwo.vue')
// const Realize = () => import('@/components/realize/index.vue')
const ProductLie = () => import('@/views/productLie.vue')
const ProductHardware = () => import('@/views/ProductHardware.vue')
const IndustryApplication = () => import('@/views/industryApplication.vue')
const AllUserCases = () => import('@/views/AllUserCases.vue')
const UserCaseDetail = () => import('@/views/UserCaseDetail.vue')
const NewsCenter = () => import('@/views/NewsCenter.vue')
const NewsDetail = () => import('@/views/NewsDetail.vue')
const AboutUs = () => import('@/views/AboutUs.vue')

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path:'/home',
    component:Home
  },
  {
    path:'/chart',
    component:Chart
  },
  // {
  //   path:'/production',
  //   component:Production,
  //   children:[
  //     {
  //       path:'1',
  //       component:ProductionBrain
  //     },
  //     {
  //       path:'2',
  //       component:YunZhaoShang
  //     },
  //     {
  //       path:'3',
  //       component:EnterInnovation
  //     },
  //     {
  //       path:'4',
  //       component:Consulting
  //     }
  //   ]
  // },
  // {
  //   path:'/threenav',
  //   component:ThreeNav
  // },
  // {
  //   path:'/fournav',
  //   component:FourNav,
  //   children:[
  //     {
  //       path:'1',
  //       component:ReportList
  //     },
  //     {
  //       path:'2',
  //       component:ReportList
  //     },
  //     {
  //       path:'3',
  //       component:ReportList
  //     },
  //   ]
  // },
  // {
  //   path:'/fivenav',
  //   component:FiveNav,
  //   children:[
  //     {
  //       path:'1',
  //       component:Realize
  //     },
  //     {
  //       path:'2',
  //       component:Realize
  //     },
  //     {
  //       path:'3',
  //       component:Realize
  //     },
  //     {
  //       path:'4',
  //       component:Realize
  //     }
  //   ]
  // },
  // {
  //   path:'/demo',
  //   component:Demo
  // },
  // {
  //   path:'/news_detail/1',
  //   component:NewsDetails
  // },
  // {
  //   path:'/news_detail/2',
  //   component:NewsDetailsTwo
  // },
  {
    path: '/product_lie',
       name: 'ProductLie',
    component: ProductLie
  },
  {
    path: '/product_hardware',
     name: 'ProductHardware',
    component: ProductHardware
  },
  {
    path: '/industry_application',
    name: 'IndustryApplication',
    component: IndustryApplication
  },
  {
    path: '/all_user_cases',
    name: 'AllUserCases',
    component: AllUserCases
  },
  {
    path: '/user_case_detail',
    name: 'UserCaseDetail',
    component: UserCaseDetail
  },

  {
    path: '/news_center',
    name: 'NewsCenter',
    component: NewsCenter,
    meta: { keepAlive:true } //需要缓存
  },
  {
    path: '/news_detail',
    name: 'NewsDetail',
    component: NewsDetail,
  },
    {
    path: '/news_detail_mobile',
    name: 'NewsDetailMobile',
    component: NewsDetailMobile,
  },
  {
    path: '/about_us',
    name: 'AboutUs',
    component: AboutUs
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router